import * as types from "../actions/index";
export default function(state = false, action) {
  switch (action.type) {
    case types.IS_IN_AUTH_PROCESS:
      return action.payload;
    // no default
  }
  return state;
}
